import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { EnterpriseSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseSpecializationPageQuery';

type EnterpriseBffSpecializationContextType =
  | {
      specializationPage?: EnterpriseSpecializationPageFieldsFragment | null;
      isS12nDataLoading?: boolean;
      error?: ApolloError;
    }
  | undefined;

const EnterpriseBffSpecializationContext = React.createContext<EnterpriseBffSpecializationContextType>(undefined);

export const useEnterpriseSpecializationPageData = () => {
  const context = useContext(EnterpriseBffSpecializationContext);

  return context?.specializationPage;
};

export const useIsEnterpriseS12nDataLoading = () => {
  const context = useContext(EnterpriseBffSpecializationContext);

  return context?.isS12nDataLoading;
};

export const useEnterpriseS12nPageError = () => {
  const context = useContext(EnterpriseBffSpecializationContext);

  return context?.error;
};

export default EnterpriseBffSpecializationContext;
